// extracted by mini-css-extract-plugin
export default {"header":"App_header__K1iLS","link":"App_link__jxMAV","button":"App_button__q51lz","subLink":"App_subLink__9R3qz","dropdownFooter":"App_dropdownFooter__YvR4A"};